"use client";

import { useSyncExternalStore } from "react";

const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | null = null;
let now = 0;

function subscribe(cb: () => void) {
  listeners.add(cb);
  if (!timer) {
    now = Date.now();
    timer = setInterval(() => {
      now = Date.now();
      listeners.forEach((l) => l());
    }, 30_000);
  }
  return () => {
    listeners.delete(cb);
    if (listeners.size === 0 && timer) {
      clearInterval(timer);
      timer = null;
    }
  };
}

/**
 * The browser's clock, refreshed every 30 s, for "5 min ago" / "resets in 3 h".
 * Null during the server render and hydration, so nothing time-relative is
 * baked into the static shell.
 */
export function useClock(): number | null {
  return useSyncExternalStore(
    subscribe,
    () => now || (now = Date.now()),
    () => null,
  );
}
